import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import "./OrderToAllocationVisibilityTable.css";
import Chevron from "../../../../../assets/images/Chvron.svg";

const OrderToAllocationVisibilityTable = ({ data = [] }) => {
  const [expanded, setExpanded] = useState({});

  const rows = useMemo(() => {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    if (Array.isArray(data?.data?.data)) return data.data.data;
    return [];
  }, [data]);

  const columns = useMemo(() => {
    if (!rows.length) return [];

    const excludeKeys = new Set(["BG", "Small C", "level_flag"]);

    return Object.keys(rows[0]).filter(
      (key) => !excludeKeys.has(key)
    );
  }, [rows]);


  const getHeatmapColor = (value) => {
    const num = Number(value);

    if (Number.isNaN(num)) return "transparent";

    if (num >= 0 && num <= 30) return "#b7e4c7";
    if (num > 30 && num <= 69) return "#ffbf69";
    if (num >= 70) return "#ff6b6b";

    return "transparent";
  };

  const renderCell = (value) => {
    return (
      <td>
        <div
          className="heatCell"
          style={{ backgroundColor: getHeatmapColor(value) }}
        >
          {value ?? ""}
        </div>
      </td>
    );
  };

  const groupByBG = (rows = []) => {
    return rows.reduce((acc, item) => {
      const bg =
        item?.BG === null || item?.BG === undefined ? " " : String(item.BG);

      if (!acc[bg]) {
        acc[bg] = {
          totalRow: null,
          rows: [],
        };
      }

      if (Number(item?.level_flag) === 1) {
        acc[bg].totalRow = item;
      } else {
        acc[bg].rows.push(item);
      }

      return acc;
    }, {});
  };

  const groupedData = useMemo(() => groupByBG(rows), [rows]);

  const toggleExpand = (bg) => {
    setExpanded((prev) => ({
      ...prev,
      [bg]: !prev[bg],
    }));
  };

  return (
    <div className="tableWrapper">
      <table className="visibilityTable">
        <thead>
          <tr>
            <th>BG / Small C</th>
            {columns.map((col) => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {Object.keys(groupedData).length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: "center" }}>
                No data available
              </td>
            </tr>
          ) : (
            Object.entries(groupedData).map(([bg, bgData]) => {
              const total = bgData.totalRow;

              return (
                <React.Fragment key={bg}>
                  {/* ✅ Parent Row */}
                  <tr className="parentRow">
                    <td>
                      <div className="mergeCell">
                        {bgData.rows.length > 0 && (
                          <button
                            type="button"
                            className="expandBtn"
                            onClick={() => toggleExpand(bg)}
                          >
                            <img
                              src={Chevron}
                              className="chevronImg"
                              style={{
                                transform: expanded[bg]
                                  ? "rotate(90deg)"
                                  : "rotate(0deg)",
                              }}
                              alt="Chevron"
                            />
                          </button>
                        )}

                        <span className="cellText">{bg}</span>
                      </div>
                    </td>

                    {columns.map((col) =>
                      renderCell(total?.[col])
                    )}
                  </tr>

                  {/* ✅ Child Rows */}
                  {expanded[bg] &&
                    bgData.rows.map((row, idx) => (
                      <tr className="childRow" key={`${bg}-${idx}`}>
                        <td>
                          <div className="mergeCell child">
                            <span className="chevronPlaceholder" />
                            <span className="cellText">
                              {row["Small C"] ?? ""}
                            </span>
                          </div>
                        </td>

                        {columns.map((col) =>
                          renderCell(row[col])
                        )}
                      </tr>
                    ))}
                </React.Fragment>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

const styles = {
  graphCard: {
    background: "#fff",
    borderRadius: "10px",
    border: "1px solid rgb(230, 230, 230)",
    padding: "10px",
  }
}
export default OrderToAllocationVisibilityTable;

OrderToAllocationVisibilityTable.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};